import axios from "axios";
import { queryParams } from "../../../../utils/queryParams";

const instance = axios.create({
  baseURL: queryParams.apiVersion + "admin/notifications"
});

export const api = {
  getNotifications(params) {
    return instance.get("", params);
  },
  addNotification(params) {
    return instance.post("", params);
  },
  editNotification(id, params) {
    return instance.put(`/${id}`, params);
  },
  removeNotification(id) {
    return instance.delete(`/${id}`);
  },
  getConfirmations(params) {
    return instance.get("/notifications", params);
  },
};
